
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/local",
      function () {
        return require("private-next-pages/local/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/local"])
      });
    }
  